<div class="linq-dialog">
	<div class="linq-dialog__header">
		<div class="col">
			<h2>{{ title }}</h2>
		</div>
	</div>

	<div class="error-items" *ngIf="error">
		{{ error }}
	</div>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<div class="linq-dialog__content linq-dialog__content_scroll">
			<sl-form [form]="form" [fields]="fields" [model]="entity" [options]="options">
			</sl-form>
		</div>
		<mat-dialog-actions class="linq-dialog__actions">
			<button mat-button class="linq-button linq-button--secondary" [mat-dialog-close]="null" (click)="onCancel()">Cancel</button>
			<span class="spacer"></span>
			<button mat-button class="linq-button linq-button--primary" type="submit" [disabled]="!form.valid">Save</button>
		</mat-dialog-actions>
	</form>
</div>
